import { useContext } from 'react';
import { intl, LanguageBaseContext } from "dmsbasereact";

export const useTreatmentDiscontinuation = () => {
    // Re-evaluate translations when language changes
    return {
        PREGNANCY: intl.get("Pregnancy").d("Pregnancy"),
        ADVERSE_EVENTS: intl.get("AdverseEvents").d("Adverse events"),
        DISEASE_PROGRESSION: intl.get("DiseaseProgression").d("Disease progression"),
        PATIENT_REFUSAL: intl.get("PatientRefusal").d("Patient refusal"),
        MEDICAL_GUIDANCE: intl.get("MedicalGuidance").d("Medical guidance"),
        TREATMENT_CHANGE: intl.get("TreatmentChange").d("Treatment change"),
        OTHER: intl.get("Other").d("Other"),
    };
};

export const useTreatmentDiscontinuationOptions = () => {
    const treatment_disc = useTreatmentDiscontinuation();

    return Object.entries(treatment_disc).map(([key, value]) => ({
        value: key,
        label: value
    }));
};
